// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box--select.select_dasboard_all .multiselect__content-wrapper {\n  max-height: 200px !important;\n}\n.active--edited {\n  background-color: rgba(28, 187, 140, 0.4392156863) !important;\n}\n.sticky-col-bg {\n  background-color: #ffffff;\n}\ntr:hover .sticky-col-bg {\n  background-color: #f8f9fa;\n}\ntr.active--edited .sticky-col-bg {\n  background-color: rgba(28, 187, 140, 0.4392156863) !important;\n}", ""]);
// Exports
module.exports = exports;
